export function areInputsNotEmpty(data, inputs) {
    for (let i = 0; i < inputs.length; i++) {
        if (!data[inputs[i]] || data[inputs[i]].trim() === "") {
            return false;
        }
    }
    return true;
}